import React from 'react';
import { locales } from '../../../../translations/locales';
import { _$, _addClass, _removeClass } from '../../../../controllers/dom';
import { NotificationManager } from 'react-notifications';

const NewSkill = (props) => {
    const { locale, theme, listSkills, newFunctionSkills, setUpdate, ModuleRP } = props;

    const createNewSkill = () => {
        for (let i = 0; i < ModuleRP.gameData.skills.length; i++) {
            const skill = ModuleRP.gameData.skills[i];
            if (skill === _$('skillName').value) {
                _addClass('skillName', ['border', 'border-danger']);
                return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
            }
        }
        if (!_$('skillName').value) {
            _addClass('skillName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        if (!listSkills) {
            return ModuleRP.config.newSkill(_$('skillName').value);
        }
        listSkills.push(_$('skillName').value);
        newFunctionSkills.push({
            skill: _$('skillName').value,
            required: true,
        });
        _removeClass('bloc-newFunction', 'hide');
        _addClass('bloc-newSkill', 'hide');
        setUpdate(new Date());
    };

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className={`hide m-4 p-1 border border-${theme === 'DARK' ? 'light' : 'dark'}`} id='bloc-newSkill'>
                <h5 className='text-center'>
                    {locales[locale].config.createNewSkill}
                </h5>
                <form
                    className='form-inline'
                    onSubmit={(event) => {
                        event.preventDefault();
                        createNewSkill();
                    }}
                >
                    <div className='form-group'>
                        <label htmlFor='skillName'>
                            {locales[locale].config.skillName}
                        </label>
                        <input type='text' id='skillName' className='form-control' placeholder={locales[locale].config.skillName} />
                        <button type='button' className='btn btn-primary' id='btn-newSkill' onClick={createNewSkill}>{locales[locale].config.create}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewSkill;
